import { call, put, SagaGenerator, select, takeLatest } from "typed-redux-saga";
import { Action } from "typescript-fsa";

import { Activity, ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { LoggerFactory } from "@com.mgmtp.a12.utils/utils-logging";

import { assertNonNullable } from "../../../utilities/assert";
import { fetchSagaFactory } from "../../../app/sagas/fetchSagaFactory";
import { handleIfOutdated } from "../../../utilities/workflowUtils";
import { mergeData } from "../../../utilities/activityUtils";
import { localizableFromLocaleResources, RESOURCE_KEYS } from "../../../localization";
import { createCustomNotificationAction } from "../../../app/actions";
import { validateLockProcess } from "../../../utilities/lockProcessUtils";

import { changeZugehoerigkeit, changeZugehoerigkeitData } from "../actions";

const logger = LoggerFactory.getLogger("changeZugehoerigkeitSaga");

export function* changeZugehoerigkeitSaga(): SagaGenerator<void> {
	yield* takeLatest(changeZugehoerigkeit.type, function* (action: Action<changeZugehoerigkeitData>) {
		if (yield* call(handleIfOutdated)) {
			return;
		}
		const { instanceId, zugehoerigkeit, activityId } = action.payload;
		const activity: Activity | undefined = yield* select(ActivitySelectors.activityById(activityId));
		assertNonNullable(activity);

		const lockValidationResult = yield* call(validateLockProcess, instanceId, action.payload.activityId);
		if (!lockValidationResult) {
			return;
		}

		yield* call(mergeData, activityId, { busy: true });

		yield* call(
			fetchSagaFactory(
				{
					relativeUrl: `/client/zugehoerigkeit?docRef=${instanceId}&zugehoerigkeit=${zugehoerigkeit}`,
					method: "POST"
				},
				function* handleResponse(response) {
					if (response.ok) {
						yield* put(ActivityActions.reloadData({ activityId: action.payload.overviewActivityId }));
						yield* put(ActivityActions.cancel({ activityId }));
					}
				},
				function* handleError(error) {
					logger.error(error);
					yield* put(
						createCustomNotificationAction({
							activityId,
							message: localizableFromLocaleResources(RESOURCE_KEYS.features.zugehoerigkeit.error),
							severity: "error",
							group: "changeClient"
						})
					);
				}
			)
		);
	});
}
